/*
 * Copyright© Celligence International, LLC - 2023
 * 
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 * 
 */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import NumberFormat from 'react-number-format';

export default function Calculator() {
  const [zipCode, setZipCode] = useState('');
  const [product, setProduct] = useState('');
  const [loanType, setLoanType] = useState('');
  const [county, setCounty] = useState('');
  const [countiesOptions, SetCountiesOptions] = useState('');
  const [propertyType, setPropertyType] = useState('');
  const [improvementCost, setImprovementCost] = useState('');
  const [zipCodeError, setZipCodeError] = useState('');
  const [productName, setProductName] = useState('');
  const [productPrice, setProductPrice] = useState('');
  const [stateList, setStateList] = useState('');
  let propertyState = '';
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);

  const [noResult, setNoresult] = useState(false);

  function getCounty() {
    if (zipCode.length === 5) {
      setZipCodeError('');
      axios
        .get(
          'https://api.reversesoftonline.com/SunsoftAPI/public/zipcode/' +
            zipCode,
          {
            headers: { 'Content-Type': 'application/json' },
          },
        )
        .then(response => {
          propertyState = stateList.filter(
            state => state.code == response.data.state,
          );
          if (!propertyState || !propertyState.length) {
            setZipCodeError(
              `We are not accepting applications for the state of ${
                response.data.state
              }`,
            );
          } else {
            setZipCodeError('');
            setCounty(response.data.counties[0].code);
            SetCountiesOptions(
              response.data.counties.map((item, index) => (
                <option key={index} value={item.code}>
                  {item.name}
                </option>
              )),
            );
          }
        })
        .catch(e => setZipCodeError(e.response.data.error));
    }

    if (zipCode.length < 5) {
      setZipCodeError('');
    }
  }

  function submitForm(event) {
    setProductPrice('');
    setProductName('');
    setNoresult(false);
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      if (zipCode.length == 5) {
        setLoading(true);
        let numOfUnits = '';

        if (product === '017') {
          numOfUnits = 1;

          if (propertyType === 'DUPLEX') {
            numOfUnits = 2;
          } else if (propertyType === 'TRIPLEX') {
            numOfUnits = 3;
          } else if (propertyType === 'FOURPLEX') {
            numOfUnits = 4;
          }
        }

        axios
          .post(
            'https://0yay21ziy1.execute-api.us-east-1.amazonaws.com/default/Appraisal_calculator',
            {
              zipCode: zipCode,
              county: county,
              propType: propertyType,
              loanType: loanType,
              origType: 'B03',
              product: product,
              numOfUnits: numOfUnits,
              totalImprovementCost: improvementCost,
            },
            {
              headers: { 'Content-Type': 'text/plain' },
            },
          )
          .then(response => {
            console.log(response);
            setProductPrice(response.data.products.price);

            // //to show the blank fields when no price is fetched
            // if(!response.data.products.price){
            //     setNoresult(true)
            // }

            //Set the product name that need to be shown in the table.
            switch (response.data.products.name) {
              case '011':
                setProductName('AVM');
                break;
              case '001':
                setProductName('Appraisal');
                break;
              case '001-INV':
                setProductName('Appraisal - Investment Property');
                break;
              case '018':
                setProductName(
                  'ClearVal Appraisal - Exterior Inspection report',
                );
                break;
              case '016':
                setProductName('Disaster Inspection');
                break;
              case '014':
                setProductName('Equivue AVM');
                break;
              case '019':
                setProductName('Field Review 2000 - Exterior-Only Report');
                break;
              case '004':
                setProductName('FNMA 1004D - CIR / Appraisal Update');
                break;
              case '009':
                setProductName('FNMA 1007 - Rent Schedule');
                break;
              case '006':
                setProductName('FNMA 1075 - Exterior-Only Ind Condo');
                break;
              case '005':
                setProductName('FNMA 2055 - Exterior-Only Report');
                break;
              case '010':
                setProductName('FNMA 2075 - Desk Review Report');
                break;
              case '008':
                setProductName('FNMA 216 - Operating Income Statement');
                break;
              case '003':
                setProductName('Home Inspection');
                break;
              case '013':
                setProductName('Occupancy Inspection');
                break;
              case '002':
                setProductName('Second Appraisal');
                break;
              case '012':
                setProductName('VA IRRRL Appraisal Review');
                break;
              case '017':
                setProductName('Consultant 203K');
                break;

              default:

              //no default
            }
            setLoading(false);
          })
          .catch(e => {
            setLoading(false);
            setNoresult(true);
            console.log(e.response.data.error);
          });
      }
    }
    setValidated(true);
  }

  useEffect(() => {
    axios
      .post(
        'https://vo4bm2sbhi.execute-api.us-east-1.amazonaws.com/prod/public/state/list',
        { companyCode: 'SUNWST000', domain: 'http://sunwestmortgage.com/' },
        {
          headers: { 'Content-Type': 'application/json' },
        },
      )
      .then(response => {
        setStateList(response.data);
      });
  }, []);

  return (
    <>
      <h1>Appraisal Calculator</h1>
      <Container>
        <Row className="justify-content-center">
          <Col md={8} className="p-4">
            <h4 className="text-center pb-3">
              Estimated Cost for an Appraisal
            </h4>
            <Form
              className="shadow rounded-lg p-4 needs-validation"
              noValidate
              validated={validated}
              onSubmit={submitForm}
            >
              <p className="small">* = Required</p>
              <Form.Row>
                <Form.Group as={Col}>
                  <Form.Label>ZIP Code: *</Form.Label>
                  <NumberFormat
                    className="form-control"
                    format="#####"
                    name="zipCode"
                    id="zipCode"
                    value={zipCode}
                    onValueChange={values => setZipCode(values.value)}
                    onBlur={getCounty}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter correct ZIP Code.
                  </Form.Control.Feedback>
                  {zipCodeError ? (
                    <div className="zip-error text-danger"><small>{zipCodeError}</small></div>
                  ) : null}
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label>Loan Type:</Form.Label>
                  <Form.Control
                    as="select"
                    custom
                    readOnly
                    name="loanType"
                    id="loanType"
                    value={loanType}
                    onChange={e => setLoanType(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="FHA/TITLE II">FHA</option>
                    <option value="VA">VA</option>
                    <option value="FMHA">USDA</option>
                    <option value="FNMA">FANNIE MAE</option>
                    <option value="FHLMC">FREDDIE MAC</option>
                    <option value="HIGH BALANCE">Conforming Jumbo</option>
                    <option value="NON CONF">NON CONFORMING</option>
                    <option value="NON PRIME">NON PRIME</option>
                    <option value="HELOC">HELOC</option>
                  </Form.Control>
                </Form.Group>
              </Form.Row>

              <Form.Row>
                <Form.Group as={Col}>
                  <Form.Label>County: *</Form.Label>
                  <Form.Control
                    as="select"
                    custom
                    name="county"
                    id="county"
                    value={county}
                    onChange={e => setCounty(e.target.value)}
                    required
                  >
                    {countiesOptions}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    County is required.
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col}>
                  <Form.Label>Product: *</Form.Label>
                  <Form.Control
                    as="select"
                    custom
                    name="product"
                    id="product"
                    value={product}
                    onChange={e => setProduct(e.target.value)} required
                  >
                    <option value="">Select</option>
                    <option value="011">AVM</option>
                    <option value="001">Appraisal</option>
                    <option value="001-INV">
                      Appraisal - Investment Property
                    </option>
                    <option value="018">
                      ClearVal Appraisal - Exterior Inspection report
                    </option>
                    <option value="016">Disaster Inspection</option>
                    <option value="014">Equivue AVM</option>
                    <option value="019">
                      Field Review 2000 - Exterior-Only Report
                    </option>
                    <option value="004">
                      FNMA 1004D - CIR / Appraisal Update
                    </option>
                    <option value="009">FNMA 1007 - Rent Schedule</option>
                    <option value="006">
                      FNMA 1075 - Exterior-Only Ind Condo
                    </option>
                    <option value="005">
                      FNMA 2055 - Exterior-Only Report
                    </option>
                    <option value="010">FNMA 2075 - Desk Review Report</option>
                    <option value="008">
                      FNMA 216 - Operating Income Statement
                    </option>
                    <option value="003">Home Inspection</option>
                    <option value="013">Occupancy Inspection</option>
                    <option value="002">Second Appraisal</option>
                    <option value="012">VA IRRRL Appraisal Review</option>
                    <option value="017">Consultant 203K</option>
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">Product is required.</Form.Control.Feedback>
                </Form.Group>
              </Form.Row>
              <Form.Group>
                <Form.Label>Property Type:</Form.Label>
                <Form.Control
                  as="select"
                  custom
                  name="propertyType"
                  id="propertyType"
                  value={propertyType}
                  onChange={e => setPropertyType(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="SFR">SINGLE FAMILY RESIDENCE (1 UNIT)</option>
                  <option value="SFR ROW">SFR/ROW</option>
                  <option value="SFR MODULAR">SFR MODULAR</option>
                  <option value="SFR ATTACHED">SFR ATTACHED HOUSING</option>
                  <option value="TOWNHOME">TOWNHOME</option>
                  <option value="MODULAR">MODULAR</option>
                  <option value="CONDO">CONDO</option>
                  <option value="B/II CONDO">B/II CONDO</option>
                  <option value="SITE CONDO">CONDO SITE (SITE-DETACHED)</option>
                  <option value="NON WARRANT">NON WARRANTABLE CONDO</option>
                  <option value="CONDO CONV">CONDO CONVERSION</option>

                  <option value="DUPLEX">DUPLEX (2 UNITS)</option>
                  <option value="TRIPLEX">TRIPLEX (3 UNITS)</option>
                  <option value="FOURPLEX">QUADPLEX (4 UNITS)</option>
                  <option value="MANUFACTURED">MANUFACTURED HOUSING</option>
                  <option value="MANUFACTURED SF">MANUFACTURED SFR</option>
                  <option value="MANUFACTURED CO">MANUFACTURED CONDO</option>

                  <option value="PUD">PUD</option>
                  <option value="MANUFACTURED PD">MANUFACTURED HOME/PUD</option>
                  <option value="COMMERCIAL">COMMERCIAL</option>
                  <option value="LAND">LAND</option>
                  <option value="COMMERCIAL LAND">COMMERCIAL LAND</option>
                  <option value="GEODESIC HOME">GEODESIC HOME</option>
                  <option value="LOG HOME">LOG HOME</option>
                </Form.Control>
              </Form.Group>

              {product === '017' ? (
                <Form.Row>
                  <Form.Group as={Col} md={6}>
                    <Form.Label>Total Improvement cost: *</Form.Label>
                    <NumberFormat
                      className="form-control"
                      thousandSeparator={true}
                      prefix={'$'}
                      placeholder="$0.00"
                      value={improvementCost}
                      onValueChange={values => setImprovementCost(values.value)}
                    />
                  </Form.Group>
                </Form.Row>
              ) : null}

              <div className="text-center my-2">
                <Button variant="primary" type="submit">
                  {loading ? 'Calculating' : 'Calculate'}
                </Button>
              </div>

              {productName ? (
                <Row className="mt-4">
                  <Col sm={11}>
                    <Table striped bordered>
                      <tbody>
                        <tr>
                          <td>Product</td>
                          <td>{productName}</td>
                        </tr>
                        <tr>
                          <td>Estimated Appraisal Cost</td>
                          <td>
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              prefix={'$'}
                              value={productPrice}
                            />
                            {productPrice ? null : '$'}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              ) : noResult ? (
                <Row className="mt-4">
                  <Col sm={11}>
                    <Table striped bordered>
                      <tbody>
                        <tr>
                          <td>Product</td>
                          <td />
                        </tr>
                        <tr>
                          <td>Estimated Appraisal Cost</td>
                          <td>$</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              ) : null}
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
}
